document.documentElement.classList.add('js');

// Mobile menu
(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-menu]');
  if (!toggle || !nav) return;
  function setOpen(open) {
    nav.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  toggle.addEventListener('click', function () { setOpen(!nav.classList.contains('is-open')); });
  nav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
})();

// Header gains a solid background once the page scrolls
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function update() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
  update();
  window.addEventListener('scroll', update, { passive: true });
})();

// Sticky buy bar: shown while no primary pre-order button is on screen
(function () {
  var bar = document.querySelector('[data-sticky-bar]');
  var ctas = document.querySelectorAll('[data-primary-cta]');
  if (!bar) return;
  if (!ctas.length || !('IntersectionObserver' in window)) { bar.hidden = false; return; }
  var visible = new Set();
  // On the product page the bar shows straight away while the buy button is off screen
  var started = bar.classList.contains('sticky-bar--product');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // Count a button as visible only when most of it is on screen
      if (entry.intersectionRatio >= 0.6) visible.add(entry.target); else visible.delete(entry.target);
    });
    // Only show after the first button has been seen and scrolled past, not on first paint
    if (visible.size) started = true;
    var show = started && visible.size === 0;
    bar.hidden = false;
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('has-sticky-bar', show);
  }, { threshold: [0, 0.6, 1] });
  ctas.forEach(function (el) { io.observe(el); });
})();

// Payment option cards: keep button and sticky bar prices in step with the selection
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input.matches('.product-form input[name="id"]')) return;
  var form = input.closest('form');
  var price = input.getAttribute('data-price');
  form.querySelectorAll('[data-button-price]').forEach(function (el) { el.textContent = price; });
  if (form.id === 'ProductForm-pdp') {
    document.querySelectorAll('[data-sticky-price]').forEach(function (el) { el.textContent = price; });
  }
});


// Quantity steppers (cart)
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-qty]');
  if (!btn) return;
  var input = btn.parentElement.querySelector('input');
  input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10));
});
